"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    className: "star_svg__path1",
    d: "M12.633 19.484l-7.388 3.884 1.411-8.226L.679 9.316l8.26-1.2L12.633.631l3.694 7.485 8.26 1.2-5.977 5.826 1.411 8.226z"
  }));
}

var MemoSvgStar = /*#__PURE__*/React.memo(SvgStar);
var _default = MemoSvgStar;
exports["default"] = _default;